import AnalysisChart from './AnalysisChart';

const EngagementAnalysis = ({ engagement }: any) => {
  return (
    <div className="flex flex-col gap-y-4 bg-[#343434] rounded-lg pt-2.5 p-2  md:p-4">
      <label className="text-xs md:text-base font-normal text-white">Engagement Analysis</label>
      <div className="flex justify-center items-center w-full h-[353px] text-center">
        <AnalysisChart engagement={engagement} />
      </div>
    </div>
  );
};

export default EngagementAnalysis;
